// from http://stackoverflow.com/a/37481846
import angular from 'angular';

module.exports = angular.module('common.directives.isolate-form', [])
.directive('isolateForm', () => {
  return {
    restrict: 'A',
    require: '?form',
    link: function(scope, element, attrs, formController) {
      if (!formController) {
        return;
      }
      var parentForm = formController.$$parentForm; // Note this uses private API
      if (!parentForm) {
        return;
      }

      // Remove this form from parent controller
      parentForm.$removeControl(formController);
    }
  };
}).name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/isolate-form.js
 **/